module.exports = __webpack_public_path__ + "img/arvore.b8dd00dd.png";